/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/KanbanCard', 'model/KanbanStyle'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./KanbanCard'), require('./KanbanStyle'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.KanbanColumn = factory(root.BpmbuildDevelopmentappspotcom.ApiClient, root.BpmbuildDevelopmentappspotcom.KanbanCard, root.BpmbuildDevelopmentappspotcom.KanbanStyle);
  }
}(this, function(ApiClient, KanbanCard, KanbanStyle) {
  'use strict';

  /**
   * The KanbanColumn model module.
   * @module model/KanbanColumn
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>KanbanColumn</code>.
   * @alias module:model/KanbanColumn
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>KanbanColumn</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/KanbanColumn} obj Optional instance to populate.
   * @return {module:model/KanbanColumn} The populated <code>KanbanColumn</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('cardList'))
        obj.cardList = ApiClient.convertToType(data['cardList'], [KanbanCard]);
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('draggable'))
        obj.draggable = ApiClient.convertToType(data['draggable'], 'Boolean');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('label'))
        obj.label = ApiClient.convertToType(data['label'], 'String');
      if (data.hasOwnProperty('maxThreshold'))
        obj.maxThreshold = ApiClient.convertToType(data['maxThreshold'], 'Number');
      if (data.hasOwnProperty('minThreshold'))
        obj.minThreshold = ApiClient.convertToType(data['minThreshold'], 'Number');
      if (data.hasOwnProperty('style'))
        obj.style = KanbanStyle.constructFromObject(data['style']);
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/KanbanCard>} cardList
   */
  exports.prototype.cardList = undefined;

  /**
   * @member {String} description
   */
  exports.prototype.description = undefined;

  /**
   * @member {Boolean} draggable
   */
  exports.prototype.draggable = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {String} label
   */
  exports.prototype.label = undefined;

  /**
   * @member {Number} maxThreshold
   */
  exports.prototype.maxThreshold = undefined;

  /**
   * @member {Number} minThreshold
   */
  exports.prototype.minThreshold = undefined;

  /**
   * @member {module:model/KanbanStyle} style
   */
  exports.prototype.style = undefined;

  /**
   * @member {String} title
   */
  exports.prototype.title = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/KanbanColumn.js